import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  base64ToFile,
  ImageCroppedEvent,
  ImageCropperComponent,
  ImageTransform
} from 'ngx-image-cropper';
import { SnackMessageService } from '../../services/snackMessage.service';
import { PictureModalLabels } from '../../models/common.model';
import { pictureModalLabels } from '../../common.labels';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-device-picture-modal',
  templateUrl: './device-picture-modal.component.html',
  styleUrls: ['./device-picture-modal.component.scss']
})
export class DevicePictureModalComponent implements OnInit {
  @ViewChild(ImageCropperComponent) private imageCropper?: ImageCropperComponent;

  className = 'app-device-picture-modal';
  labels: PictureModalLabels = pictureModalLabels;
  theme = 'marketplace-default';
  imageChangedEvent: any = '';
  croppedImage: any = '/assets/images/detail-component/ic-thing.png';
  blob: any = [];
  transform: ImageTransform = {};
  showCropper = false;
  width: number;
  height: number;
  device: any;
  inputType: any;
  widthImage: number;
  heightImage: number;
  ratio: any;
  scale = 1;
  zoomMin = 0.15;
  zoomMax = 2;

  constructor(
    private snackMessageService: SnackMessageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DevicePictureModalComponent>,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.inputType = this.storageService.getInputType();
    if (this.inputType === 'icon') {
      this.widthImage = 165;
      this.heightImage = 165;
      this.ratio = this.widthImage / this.heightImage;
    }
    if (this.inputType === 'picture') {
      this.widthImage = 962;
      this.heightImage = 563;
      this.ratio = this.widthImage / this.heightImage;
    }

    this.imageChangedEvent = this.data.image;
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
    this.blob = base64ToFile(this.croppedImage);
  }

  imageLoaded(): void {
    this.showCropper = true;
  }

  loadImageFailed(): void {
    this.snackMessageService.sendMessage('Image load error. Please try again');
  }

  back(): void {
    // closing itself and sending data to parent component
    this.dialogRef.close('cancel');
  }

  onConfirmed(): void {
    // Crop explicitly on confirm so the result never depends on auto-crop timing.
    const event = this.imageCropper?.crop('base64');
    const base64 = event?.base64 ?? this.croppedImage;

    if (!base64 || !base64.startsWith('data:')) {
      this.loadImageFailed();
      return;
    }

    this.croppedImage = base64;
    this.blob = base64ToFile(base64);
    this.dialogRef.close(base64);
  }

  zoomOut(): void {
    if (this.scale >= this.zoomMin + 0.1) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    } else {
      this.scale = this.zoomMin;
    }
  }

  updateSettings(event) {
    this.scale = event.value;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn(): void {
    if (this.scale < this.zoomMax - 0.1) {
      this.scale += 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    } else {
      this.scale = this.zoomMax;
    }
  }
}